module.exports = __webpack_public_path__ + "static/media/attach_img.3b7663a1.png";